import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import MentionsLegalesPage from "@/pages/mentions-legales/page";
import BlogPage from "@/pages/blog/page";
import ArticlePage from "@/pages/blog/ArticlePage";
import CityPage from "@/pages/serrurier-ville/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegalesPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/serrurier/:slug",
    element: <CityPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
